import { render, staticRenderFns } from "./delete-icon-renderer.vue?vue&type=template&id=e92259e0&scoped=true"
import script from "./delete-icon-renderer.vue?vue&type=script&lang=js"
export * from "./delete-icon-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92259e0",
  null
  
)

export default component.exports